import {
  List,
  Datagrid,
  TextField,
  DateField,
  TextInput,
  SimpleList,
  ShowButton,
  EditButton,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { MobileListRow } from "features/MobileListRow";
import { MOBILE_BREAKPOINT } from "utils/constants";
import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import { settings } from "app";

const listFilters = [
  <TextInput
    source="name"
    label="Име"
    alwaysOn
    resettable
  />,
];

const ListGoogleCourses = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = () => (
    <TopToolbar>
      {checkPermission(userPermissions, permissions.canCreateGoogleClassroomCourse) && <CreateButton />}
    </TopToolbar>
  );

  return (
    <List
      title="Google Зали"
      filters={listFilters}
      exporter={false}
      actions={<ListActions />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Наименование", value: record?.name }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Секция", value: record?.section }]} />
              <MobileListRow fields={[{ label: "ID в Google", value: record?.googleCourseId }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Създаден на",
                    value: (
                      <DateField
                        source="createdAt"
                        showTime
                        locales="bg-BG"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(getPermissions(), permissions.canUpdateGoogleClassroomCourse) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Наименование"
            sortable={false}
          />
          <TextField
            source="section"
            label="Секция"
            textAlign="center"
            sortable={false}
          />
          <TextField
            source="googleCourseId"
            label="ID в Google"
            textAlign="center"
            sortable={false}
          />
          <DateField
            source="createdAt"
            label="Създаден на"
            showTime
            textAlign="center"
            sortable={false}
            locales="bg-BG"
          />
          {checkPermission(getPermissions(), permissions.canUpdateGoogleClassroomCourse) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListGoogleCourses;
